export const proseClassName = [
  'prose',
  'prose-zinc',
  'dark:prose-invert',
  'prose-lg',
  'max-w-none',
  'prose-headings:font-semibold',
  'prose-headings:text-foreground',
  'prose-p:text-foreground/90',
  'prose-li:text-foreground/90',
  'prose-strong:text-foreground',
  'prose-a:text-indigo-600',
  'dark:prose-a:text-indigo-400',
  'prose-a:no-underline',
  'hover:prose-a:underline',
  'prose-blockquote:border-border',
  'prose-blockquote:text-muted-foreground',
  'prose-hr:border-border',
  'prose-code:rounded-md',
  'prose-code:bg-zinc-100',
  'dark:prose-code:bg-zinc-800/80',
  'prose-code:px-1.5',
  'prose-code:py-0.5',
  'prose-code:text-indigo-600',
  'dark:prose-code:text-indigo-300',
  'prose-code:before:content-none',
  'prose-code:after:content-none',
  'prose-pre:border',
  'prose-pre:border-zinc-200',
  'dark:prose-pre:border-zinc-700',
  'prose-pre:bg-zinc-100',
  'dark:prose-pre:bg-zinc-900/80',
].join(' ')